import React from 'react';
import {Button, Card, Form, Icon, message, Radio, Spin, Tooltip,Popover} from 'antd';
import CkInfoItem from "../../components/CkInfoItem";
import {fetchEvt} from "../../redux/actions/evt";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {inEditMode} from "../../redux/actions/global";
import {patchEventConfig} from "../../services/evt";


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewEvtModeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formLoading: false
        }
    }

    intoEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, true)
    }
    cancelEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true);
                const that = this;
                patchEventConfig(Object.assign({id: this.props.evt.header.id}, values)).then(res => {
                    if (res.code == 200) {
                        message.info("更新成功!");
                        that.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    that.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }

    render() {
        const evt = this.props.evt;
        const {getFieldDecorator, getFieldValue, getFieldError} = this.props.form;

        const editableTools = this.props.editable ?
            <div className="evt-create-editable-tools">
                <Button type="primary" size="small" onClick={this.save}>保存</Button>
                <Button type="primary" size="small" ghost onClick={this.cancelEdit}>放弃</Button>
            </div>
            :
            <div className="evt-create-editable-tools" onClick={this.intoEdit}>
                <Button type="primary" size="small" ghost>编辑</Button>
            </div>

        return (
            <Form style={{padding:0}}>
                <Spin spinning={this.state.formLoading}>
                    <Card bodyStyle={{padding: "16px"}}>
                        {editableTools}
                        <CkInfoItem
                            label={
                                <div>活动模式
                                    {/*<Popover mouseEnterDelay={0.5} content={*/}
                                        {/*<div >*/}
                                    {/*<img style={{width:500}} src={"https://img.qdj8.cn/02.jpg"}/>*/}
                                        {/*</div>*/}
                                    {/*}>*/}
                                        {/*<span title="" style={{marginLeft: "3px"}}><Icon*/}
                                            {/*type="question-circle-o"/></span>*/}
                                    {/*</Popover>*/}
                                    <Tooltip  overlayClassName='overlay-image' placement="bottom" mouseEnterDelay={0.3} title={
                                        <div style={{maxHeight:700,overflow:'auto'}}>
                                           {/* <img style={{width: 400}} src={"https://img.qdj8.cn/02.jpg"}/>*/}
                                            报名模式：同一个参与人只能报名一次（一人1票）。<br/>
                                            购票模式：允许多次购买多张票（一人多票）。<br/>
                                            请先确定好模式，如果当前选择为购票模式，有人报名后，将无法修改模式
                                        </div>
                                    }>
                                        <span title="" style={{marginLeft: "3px"}}><Icon
                                            type="question-circle-o"/></span>
                                    </Tooltip>
                                </div>
                            }
                        >
                            {
                                this.props.editable ?
                                    getFieldDecorator(`eventMode`, {
                                        initialValue: evt.config.eventMode,
                                        rules: [{required: false}],
                                    })(
                                        <Radio.Group>
                                            {
                                                Object.values(this.props.cmEnums.data.CmEventMode).map((item, index) => {
                                                    return <Radio.Button value={item.enumName.toString()}
                                                                         key={`event-mode-${index}`}>{item.enumDesc}</Radio.Button>
                                                })
                                            }
                                        </Radio.Group>
                                    )
                                    :
                                    (evt.config.eventMode ? this.props.cmEnums.data.CmEventMode[evt.config.eventMode].enumDesc : null)
                            }
                        </CkInfoItem>
                    </Card>
                </Spin>
            </Form>
        )
    }
}


EvtViewEvtModeForm.contextTypes = {}

EvtViewEvtModeForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "evtModeEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewEvtModeForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewEvtModeForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewEvtModeForm.jsx